<div
  class="form-group"
  [class.form-group-default]="!suffix()"
  [class.has-error]="hasError()"
  [class.focused]="hasFocus()"
  [class.ovflow]="tooltipKey()"
>
  <label [for]="name()" class="text-uppercase" [class.field-require]="required()" [class.m-r-10]="suffix()">
    {{ label() | translate }}
    @if (tooltipKey(); as key) {
      <i class="fa fa-question-circle" [attr.data-title]="key | translate"></i>
    }
  </label>

  @if (suffix(); as suffixText) {
    <div class="as-input-group">
      <div class="input-wrapper">
        <input
          [id]="name()"
          [name]="name()"
          [type]="type()"
          class="form-control"
          [placeholder]="placeholder()"
          [formControl]="control()"
          [autocomplete]="autocomplete()"
          (focus)="onFocus()"
          (blur)="onBlur($event)"
          (input)="onInput($event)"
          (keydown.enter)="onEnter($event)"
        />
      </div>
      <span>{{ suffixText }}</span>
    </div>
  } @else {
    <input
      [id]="name()"
      [name]="name()"
      [type]="type()"
      class="form-control"
      [placeholder]="placeholder()"
      [formControl]="control()"
      [autocomplete]="autocomplete()"
      (focus)="onFocus()"
      (blur)="onBlur($event)"
      (input)="onInput($event)"
      (keydown.enter)="onEnter($event)"
    />
  }
</div>
@if (!hideErrors()) {
  <div class="error-area">
    @if (showDomainExistError()) {
      <p class="text-danger"><i class="fal fa-triangle-exclamation"></i>&nbsp;{{ 'errors.domainExist' | translate }}</p>
    }
    <app-error-displayer [control]="control()" [maxLengthMessage]="maxLengthMessage()" />
  </div>
}
